const baseUrl = '/portfolios';
export const portfoliosRoutes = {
  baseUrl: "".concat(baseUrl),
  portfoliosId: id => "".concat(baseUrl, "/").concat(id),
  dashboard: "".concat(baseUrl, "/dashboard"),
  transfer: "".concat(baseUrl, "/transfer"),
  editPropertyPortfoliosRelationship: propertyId => "/properties/".concat(propertyId, "/portfolios")
};